/**
 * @generated SignedSource<<fe83476d619fed28fdd92771d836933c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobilePromotion_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPromotionForm_item">;
  readonly " $fragmentType": "CheckoutMobilePromotion_item";
};
export type CheckoutMobilePromotion_item$key = {
  readonly " $data"?: CheckoutMobilePromotion_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobilePromotion_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobilePromotion_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPromotionForm_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8120ec94cd6d7e7214de0df1cd7e4a67";

export default node;
